export enum SidebarListItemTypes {
  type= 'type',
  typeDetails= 'typeDetails'
}



// WEBPACK FOOTER //
// ./src/modules/common/enums/SidebarListItemTypes.ts